import React from "react"
import Head from "next/head"
import Script from "next/script"

type LayoutProps = {
  title: string
  children: React.ReactNode
  robots?: string
}

const AppLayout = ({ title, children, robots }: LayoutProps) => {
  return (
    <div>
      <Head>
        <title>{title}</title>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        {robots && <meta name="robots" content={robots} />}
      </Head>
      {children}
      <Script src="https://www.fuw.ch/_static/dnd_iframe_autofit_child.js" strategy="beforeInteractive" />
    </div>
  )
}

export default AppLayout
